import { AnalysisToolbar } from '@modules/analysis/components/AnalysisToolbar';
import { useGetAnalysisSaveActionType } from '@modules/analysis/hooks/useGetAnalysisSaveActionType';
import { useHandleQuantifyBanner } from '@modules/quantify/hooks/useHandleQuantifyBanner';
import { useGetQuantifyAnalysisActions } from './hooks';

export const QuantifyAnalysisToolbarV2 = () => {
  const { leftActions, rightActions, moreActions } =
    useGetQuantifyAnalysisActions();
  const actionType = useGetAnalysisSaveActionType();
  const bannerNode = useHandleQuantifyBanner(actionType);

  return (
    <AnalysisToolbar
      leftActions={leftActions}
      rightActions={rightActions}
      moreActions={moreActions}
      bannerNode={bannerNode}
      className="quantify-analysis-toolbar"
    />
  );
};
